module.exports = __webpack_public_path__ + "img/640.a98c1edf.gif";